import styled from '@emotion/styled';

export const AppContainerRoot = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
